/**
 * Công tắc tính năng theo tiệm (ADR-074, KH-GĐ2 4.1). Dùng chung máy chủ + web quầy.
 *
 * Luôn bật, không có công tắc: lịch hẹn, khách, tính tiền, Mini App đặt lịch, chăm khách.
 * Mỗi tính năng dưới đây là một cột `bat_*` trên `tenant_policy`; máy chủ chặn đường của tính năng tắt.
 *
 * Không dùng `Object.fromEntries` / `Object.entries`: Mini App dựng es2015 cũng nhập barrel này.
 */

export const TINH_NANG = [
  'hoa-hong',
  'goi-vi',
  'diem',
  'kho',
  'chi-nhanh',
  'phan-quyen',
  'dem-ket',
  'tien-bo',
  'khoan-chi',
  'uu-dai',
  'danh-gia',
] as const
export type TinhNang = (typeof TINH_NANG)[number]
export type BoTinhNang = Record<TinhNang, boolean>

export function laTinhNang(x: unknown): x is TinhNang {
  return typeof x === 'string' && (TINH_NANG as readonly string[]).includes(x)
}

/**
 * Tính năng ĐÃ CÓ MÃ — chỉ những cái này hiện công tắc ở "Tính năng của tiệm". Cái chưa làm vẫn có cột
 * (bật theo mức khởi đầu) để khi làm xong tự hiện đúng tiệm cần, không phải hỏi lại.
 */
export const TINH_NANG_DA_CO: readonly TinhNang[] = [
  'hoa-hong',
  'goi-vi',
  'diem',
  'kho',
  'chi-nhanh',
  'phan-quyen',
  'dem-ket',
  // KH-GĐ2 5.2 (0057).
  'tien-bo',
  // KH-GĐ2 5.3 (0058).
  'khoan-chi',
  // KH-GĐ2 GĐ3 (0061–0063).
  'uu-dai',
]

export type MucKhoiDau = 'nho' | 'co-tho' | 'lon'

/** KH-GĐ2 4.1.4. */
const BAT_THEO_MUC: Record<MucKhoiDau, readonly TinhNang[]> = {
  nho: [],
  'co-tho': ['hoa-hong', 'tien-bo', 'goi-vi', 'diem', 'uu-dai', 'khoan-chi'],
  lon: TINH_NANG,
}

export function boTheoMuc(muc: MucKhoiDau): BoTinhNang {
  const bat = BAT_THEO_MUC[muc]
  const bo = {} as BoTinhNang
  for (const t of TINH_NANG) bo[t] = bat.includes(t)
  return bo
}

/** Ba câu hỏi lúc đăng ký (KH-GĐ2 4.1.5). */
export interface TraLoiDangKy {
  soNguoi: '1' | '2-5' | '6+'
  banGoi: boolean
  hoaHong: boolean
}

export function mucTheoSoNguoi(soNguoi: TraLoiDangKy['soNguoi']): MucKhoiDau {
  if (soNguoi === '1') return 'nho'
  if (soNguoi === '2-5') return 'co-tho'
  return 'lon'
}

/**
 * Mức theo số người làm, rồi hai câu "bán gói" / "trả hoa hồng" ghi đè đúng cờ của nó — tiệm một người
 * có bán thẻ liệu trình vẫn thấy Gói và ví; tiệm 6 người không trả hoa hồng thì không thấy Hoa hồng.
 */
export function boTheoTraLoi(t: TraLoiDangKy): BoTinhNang {
  const bo = boTheoMuc(mucTheoSoNguoi(t.soNguoi))
  bo['goi-vi'] = t.banGoi
  bo['hoa-hong'] = t.hoaHong
  return bo
}
